import React from 'react';
import {
	summary,
	way,
	fee,
	provide,
	provideTable,
	refundPolicy,
	schedule,
	mobileFee,
	mobileDeposit,
} from './data';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container} from '../../../Components/Atom';
import styled from 'styled-components';
import {fontSize, fontWeight, colorPalette} from '../../../config';

const Summary = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '대회요강']} />
			<Greeting />
			<CardSection {...summary} />
			<CardSection {...way} />
			<CardSection {...fee} />
			{/* <CardSection {...provide} /> */}
			{/* <CardSection {...provideTable} /> */}
			<CardSection {...mobileFee} />
			<CardSection {...mobileDeposit} />
			<CardSection {...refundPolicy} />
			<CardSection {...schedule} />
		</Container>
	);
};

export default Summary;

const Greeting = () => {
	return (
		<GreetingSection>
			<GreetingTitle>
				<span />
				<p>인사말</p>
			</GreetingTitle>

			<GreetingBox>
				<p>
					다리를 건너면 섬이 나오고,
					<br />
					섬을 지나면 다시 바다가 펼쳐집니다.
				</p>

				<p>
					2026년 11월 7일,
					<br />그 특별한 길을 달림이 여러분과 함께 달리고 싶습니다.
				</p>

				<p>2026 일레븐 브리지 마라톤에 여러분을 초대합니다.</p>

				<p>
					일레븐 브리지 마라톤은 단순히 기록을 겨루는 대회가 아닙니다.
					<br />
					여수와 고흥 사이, 섬과 섬을 이어가는 다리 위에서
					<br />
					바람을 맞고 바다를 바라보며 달리는 여행 같은 마라톤입니다.
				</p>

				<p>
					올해 여러분은 조발대교, 둔병대교, 낭도대교, 적금대교,
					팔영대교로 이어지는 다섯 개의 다리를 달립니다.
					<br />
					어느 곳에서는 탁 트인 바다가,
					<br />
					어느 곳에서는 정겨운 섬마을이 여러분을 맞이합니다.
					<br />
					같은 바다이지만 다리를 하나씩 건널 때마다 풍경도, 바람도
					조금씩 달라집니다.
				</p>

				<p>그리고 우리는 더 큰 꿈을 꾸고 있습니다.</p>

				<p>
					11개의 다리가 모두 이어지는 날,
					<br />
					이 길을 42.195km의 마라톤 코스로 완성해 세계의 달림이들이
					찾아오는
					<br />
					‘세상에 하나뿐인 섬과 다리의 마라톤’으로 만들어가고자
					합니다.
				</p>

				<p>
					2026년은 여수가 섬의 가치와 가능성을 세계에 알린 뜻깊은
					해이기도 합니다.
					<br />
					이제 그 섬과 섬을 잇는 길 위에서 또 하나의 새로운 이야기를
					시작하려 합니다.
				</p>

				<p>
					일레븐 브리지 마라톤은 시민과 섬 주민, 자원봉사자,
					<br />
					그리고 달림이 여러분이 함께 만들어가는 대회입니다.
				</p>

				<p>
					빠르게 달리지 않아도 좋습니다.
					<br />
					잠시 속도를 늦춰 바다를 바라보셔도 좋습니다.
				</p>

				<p>
					다만, 여수의 섬과 바다를 온몸으로 느끼며 달렸던 그날만큼은
					<br />
					오래도록 기억해 주셨으면 합니다.
				</p>

				<p>
					2026년 11월 7일, 깊어가는 가을.
					<br />
					여수의 섬과 바다, 그리고 다리 위에서 여러분을
					기다리겠습니다.
				</p>

				<GreetingSignature>
					일레븐 브리지 마라톤 조직위원회
					<br />
					<strong>위원장 김경호</strong>
				</GreetingSignature>
			</GreetingBox>
		</GreetingSection>
	);
};
const GreetingSection = styled.section`
	margin-bottom: 70px;
`;

const GreetingTitle = styled.div`
	margin-bottom: 32px;
	span {
		display: block;
		width: 50px;
		height: 3px;
		background: #101d46;
		margin-bottom: 18px;
	}

	p {
		margin: 0;
		font-family: 'Gmarket';
		font-size: ${fontSize.xl3};
		font-weight: ${fontWeight.medium};
		color: #313131;
	}
`;

const GreetingBox = styled.div`
	background: #e6f4ff;
	border-radius: 12px;
	padding: 50px 60px;

	font-size: 18px;
	line-height: 1.7;
	color: #333;

	p {
		margin: 0 0 28px;
	}

	@media (max-width: 768px) {
		padding: 30px 24px;
		font-size: 16px;

		br {
			display: none;
		}
	}
`;

const GreetingSignature = styled.div`
	margin-top: 45px;
	text-align: right;
	line-height: 1.8;

	strong {
		font-size: 19px;
	}
	@media (max-width: 768px) {
		br {
			display: block;
		}
	}
`;
